export interface FileModel {
  filename?: string;
  id?: string;
}
export enum CharityFileSourceTypes {
  ASSESSMENT = 1,
  CHARITY = 2,
  PRE_ASSESSMENT = 3,
}

export enum CharityFileType {
  FILE = 1,
  IMAGE = 2,
}
